var Backbone = require('backbone');
var template = require('../templates/winner.ejs');
var _ = require('lodash');

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-winner',
    /**
     *
     */
    initialize: function(options) {
        this.model = options.model;
        this.model.winnerCopy = options.model.paragraph1.replace('{winner}','<span>'+options.model.winner_name+'</span>');
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template(_.extend({}, this.model, {
            isButtonEnabled: _.checkIfTrue(this.model['is_button_enabled'])
        })));
        return this;
    },
    /**
     *
     */
    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/winner.js